import { createHeaders } from '@wix/headers';
export function httpRequest(url) {
    return new Promise(function (resolve, reject) {
        var headers = createHeaders();
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        Object.keys(headers).forEach(function (key) {
            return xhr.setRequestHeader(key, headers[key]);
        });
        xhr.responseType = 'text';
        xhr.withCredentials = true;
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) {
                resolve(xhr.responseText);
            }
            else {
                reject(new Error("Failed to load ".concat(url, ", status ").concat(xhr.status)));
            }
        };
        xhr.onerror = function () { return reject(new Error("Failed to load ".concat(url))); };
        xhr.send();
    });
}
//# sourceMappingURL=http-request.js.map